/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useState } from 'react';

export const WalkthroughTourContext = createContext();

const WalkthroughTourContextProvider = ({ children }) => {

    const [step, setStep] = useState(0);

    return (
        <WalkthroughTourContext.Provider value={{ step, setStep }}>
            {children}
        </WalkthroughTourContext.Provider>
    );
}

export default WalkthroughTourContextProvider;
